<mat-sidenav-container >
  <mat-sidenav #stateViewSideNav [style.width.%]="isMobileView ? 100 : 50" position="end" (closed)="updateDriverBySelectedCulture()" [ngClass]="{'is-mobile-view': isMobileView}" >
    <app-culture-breakdown [selectedCulture]="selectedCulture" (closeClicked)="onCultureBreakdownClosed()"></app-culture-breakdown>
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="stateView_container" [ngClass]="{'is-mobile-view': isMobileView}">
    <div class="stateView_detailsContainer">
      <div class="stateView_headerContainer" [ngClass]="{'is-mobile-view': isMobileView}">
        <div class="stateView_headerGroupName">
          <span class="stateView_headerText" [ngClass]="{'is-mobile-view': isMobileView}">{{stateViewDashboardHeader}}</span>
        </div>
        <div class="stateView_headerGroupFiltersContainer" [ngClass]="{'is-mobile-view': isMobileView}">
          <div class="stateView_headerGroupFilter">
            <mat-form-field>
              <mat-label>{{"stateView.selectManager" | translate}}</mat-label>
              <mat-select (selectionChange)="changeManager($event.value)">
                @for(currManager of managersFilterList; track currManager.value){
                  <mat-option value="{{currManager.value}}">{{currManager.name}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          @if(isReseller){
            <div class="stateView_headerGroupFilter">
              <mat-form-field>
                <mat-label>{{"stateView.selectOrg" | translate}}</mat-label>
                <mat-select (selectionChange)="changeOrg($event.value)">
                  @for(currOrg of resellerOrgsFilterList; track currOrg.value){
                    <mat-option value="{{currOrg.value}}">{{currOrg.name}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>    
          }
        </div>
      </div>
      <mat-divider class="stateView_horizontalDivider"></mat-divider>
      <div class="stateView_detailsContentContainer" [ngClass]="{'is-mobile-view': isMobileView}">
        @if(isMobileView){
          <div class="stateView_summaryContainer">
            <span class="stateView_summaryHeader" [ngClass]="{'is-mobile-view': isMobileView}">{{"stateView.summaryOverview" | translate}}</span>
            <div class="stateView_totalEnergyContainer">
              <div class="stateView_totalEnergyHeaderContainer">
                <span class="stateView_totalEnergyHeaderText">{{"stateView.totalEnergyHeader" | translate}}</span>
                <app-claro-tooltip-icon [translatedTooltipText]="'stateView.tooltipTexts.energy' | translate" ></app-claro-tooltip-icon>
              </div>
              <mat-divider style="padding-bottom: 5px;"></mat-divider>
              <app-total-energy
              [value]="stateViewData?.totalEnergy ?? 0"
              [isLoading]="isStateDataLoading">
              </app-total-energy>
            </div>
            </div>
        }
        
        <div class="stateView_detailsContent">
          <app-culture-card-list
          [sortedFamiliesAggData]="stateViewData?.culturesData" 
          [selectedCultureId]="selectedCultureId"
          [isLoading]="isStateDataLoading"
          (onCultureSelected)="onCultureSelectedHandler($event)"
          >
          </app-culture-card-list>
          @if(false){
            <div class="stateView_details_newFeatureContainer">
              <div class="stateView_details_newFeatureHeaderContainer">
                <span class="stateView_details_newFeatureHeaderText">{{"stateView.newFeature"  | translate}}</span>
                <span class="stateView_details_newFeatureHeaderReleaseDate">{{"stateView.comingSoon"  | translate}}</span>
              </div>
              <mat-divider ></mat-divider>
            </div>
          }
        </div>
          @if(!isMobileView){
            <mat-divider vertical ></mat-divider>
            <div class="stateView_summaryContainer">
              <span class="stateView_summaryHeader" [ngClass]="{'is-mobile-view': isMobileView}">{{"stateView.summaryOverview" | translate}}</span>
              <div class="stateView_totalEnergyContainer">
                <div class="stateView_totalEnergyHeaderContainer">
                  <span class="stateView_totalEnergyHeaderText">{{"stateView.totalEnergyHeader" | translate}}</span>
                  <app-claro-tooltip-icon [translatedTooltipText]="'stateView.tooltipTexts.energy' | translate" ></app-claro-tooltip-icon>
                </div>
                <mat-divider style="padding-bottom: 5px;"></mat-divider>
                <app-total-energy
                [value]="stateViewData?.totalEnergy ?? 0"
                [isLoading]="isStateDataLoading">
                </app-total-energy>
              </div>
    
              <div class="stateView_SummaryNewFeatureContainer">
                <div class="stateView_SummaryNewFeatureHeaderContainer">
                  <span class="stateView_SummaryNewFeatureHeader">{{"stateView.newFeature"  | translate}}</span>
                  <span class="stateView_SummaryNewFeatureReleasedate">{{"stateView.comingSoon"  | translate}}</span>
                </div>
                <mat-divider ></mat-divider>
                <div class="stateView_SummaryNewFeatureContentContainer">
                  {{'stateView.commingSoonContent' | translate}}
                </div>
              </div>
            </div>
          }
      </div>
    </div>
  </div>
</mat-sidenav-content>
</mat-sidenav-container>